import React from 'react';

import { DropdownMenu } from '@/components/ui/dropdown-menu';
import { SidebarMenu, SidebarMenuItem } from '@/components/ui/sidebar';
import { useAuth } from '../../../../../../../../shared/hooks';
import DropdownMenuContent from './DropdownMenuContent';
import DropdownMenuTrigger from './DropdownMenuTrigger';

const UserSelect = () => {
  const { user } = useAuth();

  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <DropdownMenu>
          <DropdownMenuTrigger user={user} />
          <DropdownMenuContent user={user} />
        </DropdownMenu>
      </SidebarMenuItem>
    </SidebarMenu>
  );
};

export default UserSelect;
